<template>
  <div class="linha-pesquisa">
    <div class="celula medio">{{ informacoesObjeto.nome }}</div>
    <div class="celula segunda-cor-fonte">
      {{ informacoesObjeto.email }}
    </div>
    <div class="celula check">
      <unicom-checkbox
        style="width: 8px"
        unico
        :value="informacoesObjeto.idUsuarioUnimed"
        @input="value => $emit('input-check', value)"
        obrigatorio
        v-model="checkbox"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    informacoesObjeto: {
      type: Object,
      default: () => {
        return {
          id: "",
          nome: "",
          email: ""
        };
      }
    },
    checkProp: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkbox: this.checkProp
    };
  },
  watch: {
    checkProp() {
      this.checkbox = this.checkProp;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./ColunaPesquisa.scss";
</style>
